module.exports = __webpack_public_path__ + "img/bmart-icon.d8eb21b7.svg";